import { banco } from '../db/banco'
import { resolverPrecoPuro, dataISOLocal, type PrecoResolvido } from './precos'

export async function resolverPreco(
  produtoId: string,
  clienteId: string,
  tabelaPrecoId: string | null,
): Promise<PrecoResolvido | null> {
  const negociado = await banco.precos_negociados
    .where('[cliente_id+produto_id]')
    .equals([clienteId, produtoId])
    .filter((n) => n.apagado_em === null)
    .first()
  const precoTabela = tabelaPrecoId
    ? await banco.precos
        .where('[tabela_preco_id+produto_id]')
        .equals([tabelaPrecoId, produtoId])
        .filter((p) => p.apagado_em === null)
        .first()
    : undefined
  return resolverPrecoPuro(negociado, precoTabela, dataISOLocal(new Date()))
}
